import { getComputedElementStyle } from '../../utils/element-helpers';
import { PADDING } from './constants';
const getComputedMargin = (element) => {
  return (
    getComputedElementStyle(element, 'margin-top', true) +
    getComputedElementStyle(element, 'margin-bottom', true)
  );
};

export const calculateChildrenHeight = ({
  children,
  containerHeight,
  childrenElementsHeight: additionalOffset = 0,
}) => {
  let childrenElementsHeight = 0;

  // loop through children and set height
  Array.from(children).forEach((child) => {
    if (!child) return;
    if (!child.id?.startsWith('table-wrapper_')) {
      childrenElementsHeight += child.clientHeight + getComputedMargin(child);
    }
  });

  return (
    containerHeight - (PADDING + childrenElementsHeight + additionalOffset)
  );
};
